import moment from 'moment'
import { Box, Grid, GridItem, Text, Tooltip } from '@chakra-ui/react'
import React from 'react'
import type { MediaCollectionDetailsResponse } from '../../../../interfaces'
import { useTranslation } from 'react-i18next'

interface CollectionSummaryProps {
  collectionDetails: MediaCollectionDetailsResponse
}

const CollectionSummary: React.FC<CollectionSummaryProps> = ({
  collectionDetails,
}) => {
  const { t } = useTranslation()
  const creatorName = collectionDetails?.createdBy?.name
  const creatorEmail = collectionDetails?.createdBy?.email

  return (
    <Box>
      <Text fontWeight="600" mb="12px">
        {t('collection_info', 'Collection info')}
      </Text>

      <Grid
        templateColumns="120px 1fr"
        rowGap="12px"
        columnGap="16px"
        alignItems="center"
      >
        <GridItem>
          <Text color="#4b5a74">{t('last_modified', 'Last modified')}</Text>
        </GridItem>
        <GridItem>
          <Text fontWeight="500" className="updated-at">
            {collectionDetails?.updatedAt
              ? moment(collectionDetails.updatedAt).format('MMMM Do YYYY')
              : '-'}
          </Text>
        </GridItem>

        <GridItem>
          <Text color="#4b5a74">{t('created', 'Created')}</Text>
        </GridItem>
        <GridItem>
          <Text fontWeight="500" className="created-at">
            {collectionDetails?.createdAt
              ? moment(collectionDetails.createdAt).format('MMMM Do YYYY')
              : '-'}
          </Text>
        </GridItem>
      </Grid>
    </Box>
  )
}

export default CollectionSummary
